declare const jQuery: any;
const $ = jQuery;

export function initMainMenu(): void
{
    //main menu dropdown menu column if lots of menu items in sub menu
    if ($(window).width() >= 1260) {
        $('ul#menu-main-menu > li > ul.sub-menu').filter(function(){
            return this.childNodes.length > 12
        }).addClass('two-columns');
    };
}
